import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export default function RoleRoute({ children, allowedRoles = [], requireSuperUser = false }) {
  const { user } = useAuth();
  const normalizedRole = String(user?.role || "").toLowerCase();
  const normalizedAllowedRoles = allowedRoles.map((role) => String(role).toLowerCase());

  if (!user) {
    return <Navigate to="/dashboard" replace />;
  }

  // If super-user access is required
  if (requireSuperUser && normalizedRole !== "superuser") {
    return <Navigate to="/dashboard" replace />;
  }

  // Check role-based access
  if (!normalizedAllowedRoles.includes(normalizedRole)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
